// This file acts as your master "menu sheet" or database of dishes.
// In a real backend, this data would come from a database like Firestore.

export const menuData = {
  chicken: [
    { name: "Chicken Karahi", description: "A rich and aromatic classic." },
    { name: "Chicken Korma", description: "Creamy and mildly spiced chicken curry." },
    { name: "Chicken Handi", description: "Boneless chicken in a creamy tomato gravy." },
    { name: "Chicken Tikka Masala", description: "Grilled chicken chunks in a spiced curry sauce." },
    { name: "Chicken Ginger", description: "Stir-fried chicken with a strong ginger flavor." },
    { name: "Chicken Jalfrezi", description: "Chicken stir-fried with peppers and onions." },
    { name: "White Karahi", description: "A creamy karahi made with yogurt and cream." },
    { name: "Chicken Achari", description: "Tangy and spicy chicken with pickling spices." }
  ],
  lentils: [
    { name: "Daal Mash", description: "Creamy, wholesome urad lentils." },
    { name: "Daal Chana", description: "Split chickpeas in a thick gravy." },
    { name: "Daal Moong", description: "Light and easy-to-digest yellow lentils." },
    { name: "Mixed Daal", description: "A healthy blend of various lentils." },
    { name: "Daal Palak", description: "Lentils cooked with fresh spinach." }
  ],
  vegetable: [
    { name: "Aloo Gobi", description: "Classic potato and cauliflower stir-fry." },
    { name: "Mix Sabzi", description: "A medley of seasonal vegetables." },
    { name: "Bhindi Masala", description: "Okra cooked with onions and spices." },
    { name: "Aloo Palak", description: "Potatoes cooked in a spinach gravy." },
    { name: "Baingan Bharta", description: "Smoky roasted eggplant mash." }
  ],
  rice: [
    { name: "Chicken Pulao", description: "Fragrant and flavorful chicken and rice." },
    { name: "Vegetable Biryani", description: "Aromatic basmati rice with mixed vegetables." },
    { name: "Matar Pulao", description: "Basmati rice cooked with green peas." },
    { name: "Zeera Rice", description: "Cumin-tempered basmati rice." }
  ],
  beef: [
    { name: "Beef Nihari", description: "Slow-cooked beef shank stew." },
    { name: "Aloo Qeema", description: "Hearty minced meat and potato curry." },
    { name: "Beef Karahi", description: "Spicy beef cooked in a traditional karahi." }
  ]
};
